import { render, staticRenderFns } from "./WorkingDayLegend.vue?vue&type=template&id=1dfd28ac&scoped=true&"
import script from "./WorkingDayLegend.vue?vue&type=script&lang=js&"
export * from "./WorkingDayLegend.vue?vue&type=script&lang=js&"
import style0 from "./WorkingDayLegend.vue?vue&type=style&index=0&id=1dfd28ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfd28ac",
  null
  
)

export default component.exports